/* istanbul ignore file */
import { Separator } from 'features/nekst-widgets';

export default Separator;
